export default (API) => ({
    //山东应急非煤-注册到机构
    register2Branch(data) {
        return API({
            url: `/saas/v1/sdyjFmUser/register2Branch`,
            method: 'post',
            data
        })
    },
    // 山东应急非煤--查询个人信息
    findByCurr() {
        return API({
            url: `/saas/v1/sdyjFmUser/findByCurr`,
            method: 'post'
        })
    },
    // 山东应急非煤-更新个人资料
    updateSdyjWhpUser(data) {
        return API({
            url: `/saas/v1/sdyjFmUser/updateSdyjWhpUser`,
            method: 'post',
            data
        })
    },
})
